import { ALLOWED_ROLES } from "../constants";
import { OTHER_TEXT } from "../components/CareGoalsForms.schema";

export const filterActiveGoals = (goals, goalOptions) => {
  const activeGoalTextIds = [];

  goals.forEach((goal) => {
    activeGoalTextIds.push(goal.goal_text_id);
  });

  let result = [];

  goalOptions.forEach((goalOption) => {
    if (goalOption.label === OTHER_TEXT || !activeGoalTextIds.includes(goalOption.value)) {
      result.push(goalOption);
    }
  });

  return result;
};

export const getUniqueCurrentAndPastCareTeamRoles = (careTeam) => {
  const roles = new Set();

  careTeam.forEach((obj) => {
    if (ALLOWED_ROLES.includes(obj.type)) {
      roles.add(obj.type);
    }
  });

  return Array.from(roles);
};

export const getCurrentCareTeamMembersByType = (careTeam) => {
  const membersByRole = new Object();

  ALLOWED_ROLES.forEach((role) => {
    membersByRole[role] = [];
  });

  careTeam.forEach((member) => {
    if (ALLOWED_ROLES.includes(member.type) && member.is_deleted === false) {
      membersByRole[member.type].push(member);
    }
  });

  return membersByRole;
};

export const flattenObjectives = (goalsAndObjectives) => {
  const outer = {};

  goalsAndObjectives.forEach((goal) => {
    const inner = [];

    goal.objectives.forEach((objective) => {
      inner.push({
        label: objective.objective_text,
        value: objective.objective_text_id,
      });
    });

    outer[goal.goal_text_id] = inner;
  });

  return outer;
};

export const flattenGoals = (goals) => {
  const result = [];

  goals.forEach((goal) => {
    result.push({
      label: goal.goal_text,
      value: goal.goal_text_id,
    });
  });

  return result;
};

export const getGoalsMap = (goals) => {
  const result = {};

  goals.forEach((goal) => {
    result[goal.goal_text_id] = goal.goal_text;
  });

  return result;
};

export const getObjectivesMap = (goalsAndObjectives) => {
  const outer = {};

  goalsAndObjectives.forEach((goal) => {
    const inner = {};

    goal.objectives.forEach((objective) => {
      inner[objective.objective_text_id] = objective.objective_text;
    });

    outer[goal.goal_text_id] = inner;
  });

  return outer;
};
